"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var DialogContent_1 = require("@mui/material/DialogContent");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var Dialog_1 = require("@mui/material/Dialog");
var FormGroup_1 = require("@mui/material/FormGroup");
var Typography_1 = require("@mui/material/Typography");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var RetryPaymentAction = /** @class */ (function (_super) {
    __extends(RetryPaymentAction, _super);
    function RetryPaymentAction(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleRetryPaymentPopupModal = function () {
            _this.setState(function (prevState) { return ({
                showRetryPaymentPopup: !prevState.showRetryPaymentPopup
            }); });
        };
        _this.retryPayment = function (invoice) { return function () {
            _this.supportPortalService
                .retryPayment(_this.props.customerReferenceNumber, moment(invoice.dueDate).format("yyyy-MM-DD"), invoice.id)
                .subscribe();
            _this.toggleRetryPaymentPopupModal();
        }; };
        _this.doConfirmation = function () {
            _this.toggleRetryPaymentPopupModal();
            _this.props.getInvoiceAndPaymentData();
            _this.props.setUpdatedInvoiceId(_this.props.invoice.id);
        };
        _this.state = {
            showRetryPaymentPopup: false
        };
        return _this;
    }
    RetryPaymentAction.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showRetryPaymentPopup, onClose: this.doConfirmation, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogContent_1.default, { className: "pb-0 text-center", children: (0, jsx_runtime_1.jsxs)(FormGroup_1.default, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "subtitle1", className: "pb-2", children: "Payment execution has been successfully scheduled." }), (0, jsx_runtime_1.jsxs)(Typography_1.default, { variant: "subtitle1", children: [(0, jsx_runtime_1.jsx)("b", { children: "Please note" }), " that payments are queued for execution and may experience delays on high-volume dates, such as the 1st and 28th of the month."] })] }) }), (0, jsx_runtime_1.jsx)(DialogActions_1.default, { children: (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.doConfirmation, color: "primary", children: "OK" }) })] }), (0, jsx_runtime_1.jsx)(components_1.FontAwesomeIcon, { icon: "repeat", className: "fa-lg icon-spacing", onClick: this.retryPayment(this.props.invoice), type: "light", title: "Retry payment" })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], RetryPaymentAction.prototype, "supportPortalService", void 0);
    RetryPaymentAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], RetryPaymentAction);
    return RetryPaymentAction;
}(React.Component));
exports.default = RetryPaymentAction;
//# sourceMappingURL=RetryPaymentAction.js.map